export default __webpack_public_path__ + "static/media/leafAlpha.923da718.png";